import React from "react";
import Navigation from "../../organisms/Navigation/Navigation";
import Footer from "../../organisms/Footer/Footer";
import ContactBody from "../../molecules/ContactBody/ContactBody";
const Contact = () => {
  return (
    <div>
      <Navigation />
      <ContactBody />
      <Footer />
    </div>
  );
};

export default Contact;
